/*
===============================================================================
    File        =   dashboard-app/src/reducers/root.js
    Client      =   Rhealize
    Project     =   Ikimy Platform
    Purpose     =   This file contains the root reducer for the application which
                    combines all the reducers into one
                    
===============================================================================
    Revision History
        -----------------------------------------------------------------------
        Version Date        Author              Comments
        -----------------------------------------------------------------------
        1.0     2025.02.06  Moataz Khallaf      Initial Creation
        -----------------------------------------------------------------------
===============================================================================
*/
import { combineReducers } from "redux";

export default combineReducers({});
